export const extractFilename = (response: Response, fallback: string): string => {
  const disposition = response.headers.get('Content-Disposition')
  if (disposition) {
    const quoted = disposition.match(/filename="(.+)"/)
    if (quoted?.[1]) return quoted[1]

    const unquoted = disposition.match(/filename=([^\s;]+)/)
    if (unquoted?.[1]) return unquoted[1]

    const utf8 = disposition.match(/filename\*=(?:UTF-8''|utf-8'')(.+)/i)
    if (utf8?.[1]) return decodeURIComponent(utf8[1])
  }
  return fallback
}

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  try {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  } finally {
    URL.revokeObjectURL(url)
  }
}
